import { Component,Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-bats-confirm',
  templateUrl: './bats-confirm.component.html',
  styleUrls: [],
})
export class BatsConfirmComponent implements OnInit {
  
  @Input() text: string;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
  }

}
